import React from 'react';
import { Link } from 'gatsby';

function StatementContact() {
  return (
    <>
      The administrator of your personal data is GetInData Poland Sp. z o.o. with its 
      registered seat in Warsaw (02-508), 39/20 Pulawska St. 
      Your data is processed for the purpose of provision of electronic services in 
      accordance with the <Link to="/contact-terms-and-conditions" target="_blank">Terms & Conditions</Link>. For more information on personal data 
      processing and your rights please see <Link to="/privacy" target="_blank">Privacy Policy</Link>.
      <br /><br />
      By submitting this form, you agree to our Terms & Conditions and Privacy Policy
    </>
  );
}

export default StatementContact;
